export default __webpack_public_path__ + "static/cfm-ai-features-preview-c9a9ef2a5c1b00cc4bf1e2999871984f.webm";